import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { Dropdown } from "react-bootstrap";
import team3 from "../../../assets/img/team/2.jpg";
import Avatar from "../../common/Avatar";
import { AppContext } from "../../../context/AppContext";
import PATH from "../../../routes/RoutePath";
import { useApolloClient } from "@apollo/client";

const ProfileDropdown = () => {
	const { setUser } = useContext(AppContext);
	const client = useApolloClient();
	return (
		<Dropdown navbar={true} as="li">
			<Dropdown.Toggle
				bsPrefix="toggle"
				as={Link}
				to="#!"
				className="pe-0 ps-2 nav-link ">
				<img src={team3} width={30} className="rounded-circle" />
			</Dropdown.Toggle>

			<Dropdown.Menu className="dropdown-menu-card  dropdown-menu-end">
				<div className="bg-white rounded-2 py-2 dark__bg-1000">
					<Dropdown.Item className="fw-bold " href="#!">
						<Link to={PATH.ACCOUNT.MY_ACCOUNT}>My Account</Link>
					</Dropdown.Item>
					<Dropdown.Divider />

					{/* <Dropdown.Item  >
						Settings
					</Dropdown.Item> */}
					<Dropdown.Item
						onClick={() => {
							client.resetStore();
							window.localStorage.removeItem("token");
							window.localStorage.removeItem("user");
							window.localStorage.setItem("isUserLoggedIn", "false");
							setUser({
								user: {},
								isUserLoggedIn: false,
								token: "",
								isInitialized: true,
							});
						}}>
						Logout
					</Dropdown.Item>
				</div>
			</Dropdown.Menu>
		</Dropdown>
	);
};

export default ProfileDropdown;
